import { useCallback, useContext, useState } from "react";
import { UI } from "@wwimmo/ui";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "src/stores/RootStore";
import { LOADING_TYPE } from "src/stores/krediflow/InvoiceEnums";
import styles from "./InvoicePinnedComments.module.css";

import { InvoiceHistoryTimelineEntry } from "src/screens/creditors/creditor/details/history/historyTimeline/entry/InvoiceHistoryTimelineEntry";
import { ColorStyle } from "src/utils/Colors";

const InvoicePinnedCommentsBase = () => {
    const { invoiceStore } = useContext(RootStoreContext);

    const [arePinnedCommentsExpanded, setArePinnedCommentsExpanded] = useState<boolean>(false);

    const togglePinnedCommentsExpansion = useCallback(() => {
        setArePinnedCommentsExpanded((prev) => !prev);
    }, []);

    return (
        <>
            {invoiceStore.currentInvoice?.pinnedComments &&
            invoiceStore.currentInvoice?.pinnedComments.length > 0 &&
            invoiceStore.loadingType !== LOADING_TYPE.INITIALIZING ? (
                <UI.Col xs={12} className={styles.PinnedCommentsContainer}>
                    <div>
                        {invoiceStore.currentInvoice?.pinnedComments
                            .slice(0, arePinnedCommentsExpanded ? undefined : 2)
                            .map((comment, index) => {
                                return (
                                    <InvoiceHistoryTimelineEntry
                                        key={index}
                                        historyEntry={comment}
                                        displayTimeLine={false}
                                    />
                                );
                            })}
                        {invoiceStore.currentInvoice?.pinnedComments.length > 2 && (
                            <div
                                onClick={togglePinnedCommentsExpansion}
                                style={{
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    marginTop: "8px",
                                    justifyContent: "center"
                                }}
                            >
                                <UI.Icon
                                    icon={arePinnedCommentsExpanded ? UI.SVGIcon.ChevronUp : UI.SVGIcon.ChevronDown}
                                    color={ColorStyle("primary")}
                                    size={25}
                                />
                            </div>
                        )}
                    </div>
                </UI.Col>
            ) : undefined}
        </>
    );
};

export const InvoicePinnedComments = Sentry.withProfiler(observer(InvoicePinnedCommentsBase));
